import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PanelService from 'services/panelsService';
import { formatValidationErrors } from 'utils/ArrayUtils';

export const initialState = {
    list : [],
    fetching: false,
    creating: false,
    updating : false,
    deleting : false,
    errorMessages: [],
    showMessage: false,
    showEditForm : false,
    showNewForm : false,
}

export const fetchPanels = createAsyncThunk('/fetchPanels', async (data, {rejectWithValue }) => {
    try {
            const response = await PanelService.fetch();
            var code = response.code;	
            return {
                code: code,
                panels : response.data
            };
    } catch (err) {
        let code = err.response?.data.code;
        let response = err.response;
        return rejectWithValue({
            code: code,
            errorMessages: response?.data?.message || 'Error'
        });
    }
});

export const createPanel = createAsyncThunk('/createPanel',async (data, { rejectWithValue }) => {
    try {
        const response = await PanelService.create(data)
        const code  = response.original.code;
        return {
            code: code,
            panels : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating the panel"})
    }
})

export const updatePanel = createAsyncThunk('/updatePanel',async (data, { rejectWithValue }) => {
    try {
        const response = await PanelService.update(data)
        const code = response.original.code;
        return {
            code: code,
            panels : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating the panel"})
    }
})

export const deletePanel = createAsyncThunk('/deletePanel',async (id, { rejectWithValue }) => {
    try {
        const response = await PanelService.delete(id)
        const code = response.original.code;
        return {
            code: code,
            panels : response.original.data
        };
    } catch (err) {
        return rejectWithValue({error : "Error deleting the panel"})
    }
})

export const PanelSlice = createSlice({
    name: 'panels',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.fetching = !state.fetching
        },
        togglePanelEditForm : (state) => {
            state.showEditForm =  !state.showEditForm;
        },
        togglePanelNewForm : (state) => {
            state.showNewForm  = !state.showNewForm        
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPanels.pending, (state) => {
                state.fetching = true
            })
            .addCase(fetchPanels.fulfilled, (state, action) => {
                state.fetching = false
                state.list = action.payload.panels
            })
            .addCase(fetchPanels.rejected, (state, action) => {
                state.fetching = false
            })
            .addCase(createPanel.pending, (state) => {
                state.creating = true
            })
            .addCase(createPanel.fulfilled, (state, action) => {
                state.creating = false
                state.list = action.payload.panels
                state.showNewForm = !state.showNewForm;
            })
            .addCase(createPanel.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    // state.errorMessages = action.payload.error;
                    state.list = state.list;
                }
                state.creating = false;
            })
            .addCase(updatePanel.pending, (state, action) => {
                state.updating = true
            })
            .addCase(updatePanel.fulfilled, (state, action) => {
                state.updating = false
                state.list = action.payload.panels
                state.showEditForm = !state.showEditForm
            })
            .addCase(updatePanel.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    state.errorMessages = action.payload.error;
                }
                state.updating = false
            })
            .addCase(deletePanel.pending, (state, action) => {
                state.deleting = true
            })
            .addCase(deletePanel.fulfilled, (state, action) => {
                state.deleting = false
                state.list = action.payload.panels
            })
            .addCase(deletePanel.rejected, (state, action) => {
                state.deleting = false
            })
    },
})

export const { 
    showLoading,
    togglePanelEditForm,
    togglePanelNewForm
} = PanelSlice.actions

export default PanelSlice.reducer